module.exports = require('./dist/cjs/graphql/index');
